import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
	apiKey: "AIzaSyAXe14KO-81hnQfK5Fh6Pp-IGjCumaN_js",
	authDomain: "mastergrill-software.firebaseapp.com",
	projectId: "mastergrill-software",
	storageBucket: "mastergrill-software.appspot.com",
	messagingSenderId: "93891702358",
	appId: "1:93891702358:web:e842e59f2c139e3e92d5f7",
	measurementId: "G-2Y19PNZ918",
};

initializeApp(firebaseConfig);
getAnalytics();
getPerformance();

const auth = getAuth();
auth.useDeviceLanguage();

const functions = getFunctions();
functions.region = "europe-west3";
